import React from "react";

export default function LoadingBtn({style}) {
  return (
    <div
      style={style ?? {}}
      className="spinner-border spinner-border-sm text-light"
      role="status"
    ></div>
  );
}
